import { parseKeywordIntegratedSearchMagazineVo } from '@/parsers/search';

import { useGetKeywordSearchMagazineQuery } from './search.gql.impl';

const KEYWORD_SEARCH_SIZE = 4;

const useGetKeywordIntegratedSearchMagazine = (keyword: string) => {
  const {
    data: keywordSearchMagazine,
    isLoading: isKeywordSearchMagazineLoading,
  } = useGetKeywordSearchMagazineQuery(
    {
      request: {
        keyword,
        size: KEYWORD_SEARCH_SIZE,
      },
    },
    {
      select: parseKeywordIntegratedSearchMagazineVo,
      enabled: keyword.length > 1,
    },
  );

  return {
    keywordSearchMagazine,
    isKeywordSearchMagazineLoading,
  };
};

export default useGetKeywordIntegratedSearchMagazine;
